import { type RouterFacade } from '@teachino/shared-router';
import { type AnalyticsFacade } from '../analytics/analytics.facade';
import type { ConfigFacade } from '../config/config.facade';
import type { UserFacade } from '../user/user.facade';
import { DiContainer } from './di-container';

const diContainer = new DiContainer<{
  user: UserFacade;
  analytics: AnalyticsFacade;
  config: ConfigFacade;
  router: RouterFacade;
}>();
export function useGlobalDependencyProvider() {
  return diContainer;
}
